<template>
  <div class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>排班站看板</h3>
          <el-row :gutter="20">
            <el-col :span="8" class="updateTime flex-center">
              <span class="fontSize20 mr-2">
                倒數：{{ time }}秒更新, 上次更新時間{{ lastUpdateTime }}
              </span>
              <button
                type="button"
                @click="refreshPage"
                class="mybtnstyle btn-primary fontSize16"
              >
                重新整理
              </button>
            </el-col>
          </el-row>
          <el-row :gutter="5" align="middle">
            <el-col :span="2" class="flex-center">
              <span class="fontSize20">發缺車訊息:</span>
            </el-col>
            <el-col :span="3" class="flex-center">
              <el-input v-model="scheduledName" placeholder=""></el-input>
            </el-col>
            <el-col :span="4" class="flex-center">
              <select
                class="inputstyle"
                v-model="select.shiftName"
                @change="_onShiftAreaChange(select.shiftName)"
              >
                <option value="insert">--請選擇--</option>
                <option
                  v-for="station in options.shift_area_arr"
                  :value="station.name"
                >
                  {{ station.name }}
                </option>
              </select>
            </el-col>
            <el-col :span="3" class="flex-center">
              <div class="vertical-group">
                <button
                  type="button"
                  @click="sendFailingCarMessage"
                  class="mybtnstyle btn-danger fontSize16"
                >
                  發缺車訊息
                </button>
                <el-checkbox v-model="onlyEmpty" style="margin-top: 8px">
                  只發給空車
                </el-checkbox>
              </div>
            </el-col>
            <el-col :span="2" class="flex-center">
              <span class="fontSize20">歷史查詢:</span>
            </el-col>
            <el-col :span="4" class="flex-center">
              <select
                class="inputstyle"
                v-model="select.shiftName1"
                @change="_onShiftAreaNameChange(select.shiftName1)"
              >
                <option value="insert">--請選擇--</option>
                <option
                  v-for="station in options.shift_area_arr"
                  :value="station.name"
                >
                  {{ station.name }}
                </option>
              </select>
            </el-col>
            <el-col :span="5" class="flex-center">
              <input
                v-model="callNumber"
                type="text"
                required="required"
                class="inputstyle fontSize16"
                placeholder="隊編/呼號"
              />
              <button
                type="button"
                @click="_getDriverHistoryInfo"
                class="mybtnstyle btn-success fontSize16"
              >
                搜尋
              </button>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <SampleBroad
      class="sample-broad-margin"
      :shiftDriver="shiftDriver"
      @driver-scheduled-info="_getDriverInfo"
      @removeShift="_reomveMemberShift"
    ></SampleBroad>
    <el-dialog
      title="司機排班狀況"
      :visible.sync="dialogTableVisible"
      :before-close="handleClose"
    >
      <h4>手動插班</h4>
      <el-row :gutter="20">
        <el-col :span="6">
          <input
            v-model="transfer.shiftAreaName"
            type="text"
            required="required"
            class="inputstyle col-md-12 fontSize16"
            placeholder="排班站"
            disabled
          />
        </el-col>
        <el-col :span="6">
          <input
            v-model="transfer.account"
            type="text"
            required="required"
            class="inputstyle col-md-12 fontSize16"
            placeholder="電話"
            disabled
          />
        </el-col>
        <el-col :span="6">
          <input
            v-model="transfer.callNumber"
            type="text"
            required="required"
            class="inputstyle col-md-12 fontSize16"
            placeholder="隊編/呼號"
            disabled
          />
        </el-col>
        <el-col :span="6">
          <input
            v-model="transfer.time"
            type="text"
            required="required"
            class="inputstyle col-md-12 fontSize16"
            placeholder="時間"
          />
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top: 8px">
        <el-col :span="4">
          <el-button type="danger" @click="moveToHead(transfer)">
            插頭班
          </el-button>
        </el-col>
        <el-col :span="4" :offset="16">
          <el-button type="primary" @click="_updateShiftSort">
            自由插班
          </el-button>
        </el-col>
      </el-row>
      <el-table :data="clickdriverScheduledOnTable">
        <el-table-column
          prop="callNumber"
          label="隊編/呼號"
          width="150"
        ></el-table-column>
        <el-table-column prop="account" label="司機電話"></el-table-column>
        <el-table-column
          prop="shiftUpdatedTime"
          label="排班時間(頭 -> 尾)"
        ></el-table-column>
        <el-table-column property="flag" label="標記"></el-table-column>
        <el-table-column label="插班">
          <template slot-scope="scope">
            <el-button
              v-show="
                clickdriverScheduledOnTable[scope.$index].flag === '歷史資料'
              "
              type="primary"
              @click="_clickUpdateShiftSortOnTable(scope.$index)"
            >
              插班
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <div
      id="modalDriverScheduledInfo"
      class="modal fade bd-example-modal-lg"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="exampleModalLabel">司機歷史派遣資料</h3>
          </div>
          <table class="table table-striped jambo_table bulk_action">
            <thead>
              <tr class="headings">
                <th class="column-title word_center">隊編/呼號</th>
                <th class="column-title word_center">排班區</th>
                <th class="column-title word_center">司機電話</th>
                <th class="column-title word_center">排班時間</th>
                <th class="column-title word_center">標記</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="pointer fontSize16 point text_hailing dropdown"
                v-for="(item, index) in driverScheduled"
              >
                <td class="word_center">{{ item.callNumber }}</td>
                <td class="word_center">{{ item.shiftAreaName }}</td>
                <td class="word_center">{{ item.account }}</td>
                <td class="word_center">{{ item.shiftUpdatedTime }}</td>
                <td
                  class="word_center"
                  :class="{
                    'red-style': driverScheduled[index].flag === '歷史資料',
                  }"
                >
                  {{ item.flag }}
                </td>
              </tr>
            </tbody>
          </table>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              關閉
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import API from '@/assets/js/libs/API'
import moment from 'moment'
import { Notification } from 'element-ui'
import { cookies } from '@/utils/cookies'
import SampleBroad from '@/components/areaComponent/simpleBroad'
import Shift_area from '@/assets/js/libs/Shift_area'
import Dispatch_area from '@/assets/js/libs/Dispatch_area'
import Message from '@/assets/js/libs/Message'
import BehaviorRecorder from '@/assets/js/libs/BehaviorRecorder'
import Driver from '@/assets/js/libs/Driver'
import dayjs from 'dayjs'

const driver = new Driver()
const message = new Message()
const shift_area = new Shift_area()
const dispatch_area = new Dispatch_area()

export default {
  components: {
    SampleBroad,
  },
  data() {
    return {
      shiftName: [],
      shiftDriver: [],
      stopTime: false,
      time: 16,
      timeout: null,
      driverPhone: '',
      driverScheduled: [],
      clickdriverScheduledOnTable: [],
      callNumber: '',
      options: {
        dispatch_area_arr: [],
        shift_area_arr: [],
      },
      select: {
        shiftName: '請選擇',
        shiftName1: '請選擇',
      },
      transfer: {
        callNumber: '',
        account: '',
        time: '',
        shiftAreaName: '',
      },
      lastUpdateTime: '',
      dialogTableVisible: false,
      scheduledName: '',
      onlyEmpty: true,
    }
  },
  mounted() {
    this.getShiftInfo()
    this.counter()
    this._getOptions()
  },
  methods: {
    moveToHead(data) {
      let array = this.shiftDriver.filter((element) => {
        if (element.name === data.shiftAreaName) {
          return element.driverInfo
        }
      })
      let payload = {
        driverPhone: this.transfer.account,
        shiftAreaName: this.transfer.shiftAreaName,
        shiftDate: new Date(
          moment(array[0].driverInfo[0].shiftUpdatedTime)
            .subtract(1, 'second')
            .utc()
            .format(),
        ).toISOString(),
      }

      API.put('service/shift', payload)
        .then((res) => {
          BehaviorRecorder.record(
            '點擊',
            '排班看板',
            `插頭班<${payload.shiftAreaName}>` +
              `&&司機: ${this.transfer.callNumber}` +
              `&&排班時間: ${dayjs(payload.shiftDate).format('YYYY-MM-DD HH:mm:ss')}`,
          )
          /* alert(res.message) */
          Notification({
            message: res.message,
            type: 'success',
          })
          this.clearSchedualBoard()
          this.getAllShiftDriver()
          this.transfer.callNumber = ''
          this.transfer.account = ''
          this.transfer.time = ''
          this.transfer.shiftAreaName = ''
          this.dialogTableVisible = false
        })
        .catch((e) => {
          console.error('通知乘客： ' + e)
        })
    },
    handleClose(done) {
      this._clearMemberShift()
      done()
    },
    async getDriverLocations() {
      let callNumber = await driver
        .getAllDriverLocation(1, this.onlyEmpty)
        .then((res) => {
          let driverList = res.result.map((e) => {
            return e.callNumber
          })
          return driverList.join(',')
        })
        .catch((e) => {
          console.error(e)
        })
      let callNumber1 = await driver
        .getAllDriverLocation(2, this.onlyEmpty)
        .then((res) => {
          let driverList = res.result.map((e) => {
            return e.callNumber
          })
          return driverList.join(',')
        })
        .catch((e) => {
          console.error(e)
          // this.loader.hide()
        })
      let callNumber2 = await driver
        .getAllDriverLocation(3, this.onlyEmpty)
        .then((res) => {
          let driverList = res.result.map((e) => {
            return e.callNumber
          })
          return driverList.join(',')
        })
        .catch((e) => {
          console.error(e)
        })
      let callNumber3 = await driver
        .getAllDriverLocation(4, this.onlyEmpty)
        .then((res) => {
          let driverList = res.result.map((e) => {
            return e.callNumber
          })
          return driverList.join(',')
        })
        .catch((e) => {
          console.error(e)
        })
      return (
        callNumber + ',' + callNumber1 + ',' + callNumber2 + ',' + callNumber3
      )
    },
    async sendFailingCarMessage() {
      message
        .pushDriverMessage(
          {
            announcer: cookies.get('GladName'),
            teamCode: cookies.get('GladTeamCode').toString(),
            content: `目前${this.scheduledName}缺車，請附近空車前往支援排班`,
            callNumber: await this.getDriverLocations(),
            reference: '排班看板',
          },
          'one',
        )
        .then((res) => {
          this.isloading = false
          if (res.success) {
            /* alert('傳送成功') */
            Notification({
              message: '傳送成功',
              type: 'success',
            })
            this.black = null
          } else {
            /* alert('傳送失敗，有可能呼號錯誤') */
            Notification({
              message: '傳送失敗，有可能呼號錯誤',
              type: 'error',
            })
          }
        })
        .catch((e) => {
          console.error(e)
          Notification({
            message: '傳送失敗' + e.message,
            type: 'error',
          })
        })
    },
    refreshPage() {
      this.$router.go(0)
    },
    counter() {
      if (this.stopTime) {
        this.timeout = null
      } else if (this.time <= 1) {
        this.time = 16
        this.clearSchedualBoard()
        this.getAllShiftDriver()
        this.timeout = setTimeout(this.counter, 1000)
      } else {
        this.timeout = setTimeout(this.counter, 1000)
      }
      this.time -= 1
    },
    startTimer() {
      this.stopTime = false
      this.counter()
      this.getList()
    },
    stopTimer() {
      this.stopTime = true
    },
    clearSchedualBoard() {
      this.shiftDriver = []
    },
    getShiftInfo() {
      API.get(`/shift-area/identificaiton-code`)
        .then((res) => {
          if (res.err === '無此車隊排班站資料') return
          let array = []
          for (let i = 0; i < res.result.length; i++) {
            this.shiftName.push(res.result[i].name)
            // this.shiftName = array.sort()
          }
          this.getAllShiftDriver()
        })
        .catch((e) => {
          console.error(e)
        })
    },
    _getDriverHistoryInfo() {
      if (this.callNumber === '') {
        /* alert('請輸入隊編/呼號') */
        Notification({
          message: '請輸入隊編/呼號',
          type: 'warning',
        })
        return
      }
      API.get(
        `/service/shift/record/?callNumber=${this.callNumber}&shiftAreaName=${this.select.shiftName1}`,
      )
        .then((res) => {
          if (res.err === '找不到該位司機的排班資料') {
            /* alert('找不到該位司機的排班資料') */
            Notification({
              message: '找不到該位司機的排班資料',
              type: 'error',
            })
            return
          }
          let driverArray = res.result.filter((element) => {
            return element.action === 'import'
          })
          // 合併
          let combin = driverArray
          // 重新整理
          let sortArray = []
          for (let i = 0; i < combin.length; i++) {
            let info = {}
            info.account = combin[i].account
            info.callNumber = combin[i].callNumber
            info.shiftUpdatedTime = moment(combin[i].shiftUpdatedTime).format(
              'YYYY-MM-DD HH:mm:ss',
            )
            info.shiftAreaName = combin[i].shiftAreaName
            if (combin[i].flag === undefined) {
              info.flag = '歷史資料'
            } else {
              info.flag = combin[i].flag
            }
            sortArray.push(info)
          }
          sortArray.sort(function (a, b) {
            return new Date(a.shiftUpdatedTime) - new Date(b.shiftUpdatedTime)
          })
          this.openModal(sortArray)
        })
        .catch((e) => {
          console.error(e)
        })
    },
    _getShiftRecordAPI(callNumber, shiftName) {
      API.get(
        `/service/shift/record/?callNumber=${callNumber}&shiftAreaName=${shiftName}`,
      )
        .then((res) => {
          if (res.err === '找不到該位司機的排班資料') {
            /* alert('找不到該位司機的排班資料') */
            Notification({
              message: '找不到該位司機的排班資料',
              type: 'error',
            })
            return
          }
          let driverArray = res.result.filter((element) => {
            return element.action === 'import'
          })
          let array = this.shiftDriver.filter((element) => {
            if (element.name === shiftName) {
              return element.driverInfo
            }
          })
          // 排班站內的司機
          // 合併
          let combin = array[0].driverInfo.concat(driverArray)
          // 重新整理
          let sortArray = []
          for (let i = 0; i < combin.length; i++) {
            let info = {}
            info.account = combin[i].account
            info.callNumber = combin[i].callNumber
            info.shiftUpdatedTime = moment(combin[i].shiftUpdatedTime).format(
              'YYYY-MM-DD HH:mm:ss',
            )
            info.shiftAreaName = combin[i].shiftAreaName
            // console.log(combin[i].flag === undefined)

            if (combin[i].flag === undefined) {
              info.flag = '歷史資料'
            } else {
              info.flag = combin[i].flag
            }
            sortArray.push(info)
          }
          sortArray.sort(function (a, b) {
            return new Date(a.shiftUpdatedTime) - new Date(b.shiftUpdatedTime)
          })
          this.clickdriverScheduledOnTable = sortArray
        })
        .catch((e) => {
          console.error(e)
        })
    },
    getAllShiftDriver() {
      API.get(`/service/shift`)
        .then((res) => {
          let driverSchedualingInfo = []
          this.lastUpdateTime = moment().format('HH:mm:ss')
          if (res.err === '找不到車隊排班資料') {
            driverSchedualingInfo = []
            for (let i = 0; i < this.shiftName.length; i++) {
              let info = {
                name: this.shiftName[i],
                driverInfo: [],
              }
              this.shiftDriver.push(info)
            }
            return
          }
          driverSchedualingInfo = this.sortTime(res.result)
          for (let i = 0; i < this.shiftName.length; i++) {
            let info = null
            let driverInfo = []
            for (let j = 0; j < driverSchedualingInfo.length; j++) {
              if (
                this.shiftName[i] === driverSchedualingInfo[j].shiftAreaName &&
                driverSchedualingInfo[j].state === 4
              ) {
                driverInfo.push({
                  flag: '排班中',
                  account: driverSchedualingInfo[j].account,
                  state: driverSchedualingInfo[j].state,
                  driverNote: driverSchedualingInfo[j].driverNote,
                  callNumber: driverSchedualingInfo[j].callNumber,
                  shiftUpdatedTime: moment(
                    driverSchedualingInfo[j].shiftUpdatedTime,
                  ).format('YYYY-MM-DD HH:mm:ss'),
                })
              }
            }
            info = {
              name: this.shiftName[i],
              driverInfo,
            }
            this.shiftDriver.push(info)
          }
        })
        .catch((e) => {
          console.error(e)
        })
    },
    _clearMemberShift() {
      this.clickdriverScheduledOnTable = []
      this.transfer.callNumber = ''
      this.transfer.account = ''
      this.transfer.time = ''
      this.transfer.shiftAreaName = ''
    },
    openModal(val) {
      this.driverScheduled = val
      $('#modalDriverScheduledInfo').modal('show')
    },
    sortTime(schedualArray) {
      return schedualArray.sort(function (a, b) {
        return new Date(a.shiftUpdatedTime) - new Date(b.shiftUpdatedTime)
      })
    },
    _onShiftAreaNameChange(val) {
      /* console.log(val) */
      this.select.shiftName1 = val
    },
    _onShiftAreaChange(val) {
      /* console.log(val) */
      if (this.scheduledName === '') {
        this.scheduledName = val
        return
      }
      this.scheduledName = this.scheduledName + ',' + val
    },
    _getOptions() {
      API.get(`/shift-area/identificaiton-code`)
        .then((res) => {
          if (res.err === '無此車隊排班站資料') return
          this.options.shift_area_arr = res.result
          let schedualArea = res.result
        })
        .catch((e) => {
          console.error(e + '錯誤代碼: area:001')
        })
    },
    _getDriverInfo(value) {
      this.transfer.callNumber = value.callNumber
      this.transfer.account = value.account
      this.transfer.time = value.shiftUpdatedTime
      this.transfer.shiftAreaName = value.shiftName
      this._getShiftRecordAPI(
        this.transfer.callNumber,
        this.transfer.shiftAreaName,
      )
      this.dialogTableVisible = true
    },
    _clickUpdateShiftSortOnTable(index) {
      let payload = {
        driverPhone: this.clickdriverScheduledOnTable[index].account,
        shiftAreaName: this.clickdriverScheduledOnTable[index].shiftAreaName,
        shiftDate: new Date(
          moment(this.clickdriverScheduledOnTable[index].shiftUpdatedTime)
            .utc()
            .format(),
        ).toISOString(),
      }

      API.put('service/shift', payload)
        .then((res) => {
          BehaviorRecorder.record(
            '點擊',
            '排班看板',
            `插班<${payload.shiftAreaName}>` +
              `&&司機: ${this.transfer.callNumber}` +
              `&&排班時間: ${dayjs(payload.shiftDate).format('YYYY-MM-DD HH:mm:ss')}`,
          )
          /* alert(res.message) */
          Notification({
            message: res.message,
            type: 'success',
          })
          this.clearSchedualBoard()
          this.getAllShiftDriver()
          this.clickdriverScheduledOnTable = []
          this.dialogTableVisible = false
        })
        .catch((e) => {
          console.error('通知乘客： ' + e)
        })
    },
    _updateShiftSort() {
      let payload = {
        driverPhone: this.transfer.account,
        shiftAreaName: this.transfer.shiftAreaName,
        shiftDate: new Date(
          moment(this.transfer.time).utc().format(),
        ).toISOString(),
      }
      // console.log(payload)

      API.put('service/shift', payload)
        .then((res) => {
          BehaviorRecorder.record(
            '點擊',
            '排班看板',
            `自由排班<${payload.shiftAreaName}>` +
              `&&司機: ${this.transfer.callNumber}` +
              `&&排班時間: ${dayjs(payload.shiftDate).format('YYYY-MM-DD HH:mm:ss')}`,
          )
          if (res.success) {
            this.$msg(res.message)
            this.clearSchedualBoard()
            this.getAllShiftDriver()
            this.transfer.callNumber = ''
            this.transfer.account = ''
            this.transfer.time = ''
            this.transfer.shiftAreaName = ''
            this.dialogTableVisible = false
            return
          }
          this.$msg(res.message)
        })
        .catch((e) => {
          console.error('通知乘客： ' + e)
        })
    },
    _reomveMemberShift(info) {
      let payload = {
        callNumber: info.callNumber,
        shiftAreaName: info.shiftName,
        driverPhone: info.account,
      }
      API.delete(`service/shift`, { data: payload })
        .then((res) => {
          if (!res.success) throw new RangeError(res.error)
          /* alert(res.message) */
          Notification({
            message: res.message,
            type: 'success',
          })
          this.clearSchedualBoard()
          this.getAllShiftDriver()
        })
        .catch((e) => {
          this.$msg(e)
        })
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
    this.timeout = null
  },
}
</script>
<style scoped>
.red-style {
  background-color: #ff4d4d;
}

.title_left .el-row {
  margin: 1rem;
}
.updateTime {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.flex-center {
  display: flex;
  align-items: center;
  height: 40px;
}

.inputstyle {
  height: 36px;
}

.mybtnstyle {
  height: 36px;
  margin: 0;
}

.el-input {
  width: 100%;
}

.mr-2 {
  margin-right: 1rem;
}

.vertical-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
}

.vertical-group button {
  margin-top: 0;
}

.vertical-group .el-checkbox {
  margin-top: 16px;
}

.sample-broad-margin {
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/area/ShiftBoard.vue